/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconWrench: {
  name: 'wrench';
  data: string;
} = {
  name: 'wrench',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M580.342 162.345 454.467 288.22l-107.61-28.629-28.629-107.608L444.102 26.109l.001-.003c-63.18-16.307-133.19-.089-182.639 49.362-52.434 52.433-67.895 127.93-46.395 193.971L20.342 464.166v124.259h120.07l196.935-196.934c65.96 21.337 141.29 5.836 193.633-46.507 49.503-49.503 65.756-119.405 49.362-182.639z"/></svg>`,
};
